<template lang="">
    <div class="bilan p-0" v-if="!mobileView">
        <div class="row" v-if="validation_financiere_ligne_temps.length > 0">
            <p class="col-12 col-md-6"><span class="font-weight-bold">Validation Medicasure:</span>  {{ validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_medecin != null ? formattedDateTime(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_medecin) : formattedDateTime(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].created_at) }}</p>
            <p class="col-12 col-md-6"><span class="font-weight-bold">Validation Souscripteur:</span>  {{ formattedDateTime(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_souscripteur) }}</p>
            <p class="col-12 col-md-6"><span class="font-weight-bold">Temps de validation:</span>  {{ computeTempsValidation(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_medecin != null ? validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_medecin : validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].created_at, validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_souscripteur) }}</p>
        </div>
        <div class="bilan__content">
            <h5 class="text-center fs-3 fw-bold">Version {{ version }}</h5>
            <table>
                <thead>
                    <tr>
                        <th>EXAMENS COMPLEMENTAIRES</th>
                        <th>PRIX</th>
                        <th> MEDICASURE</th>
                        <th>SOUSCRIPTEUR</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(validation, index_val) in validation_financiere_ligne_temps" :key="'validation_financiere_ligne_temp'+index_val">
                    <td>{{ validation.examen }}</td>
                    <td>{{ displayNumber(validation.prix) }}</td>
                    <td class="text-center">
                        <span class="text-success" v-if="validation.etat_validation_medecin == 1"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
                        <span class="text-danger" v-else><i class="fa fa-times" aria-hidden="true"></i></span>
                    </td>
                    <td class="text-center">
                        <span v-if="validation.etat_validation_souscripteur" class="text-success"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
                        <span v-else class="text-danger"><i class="fa fa-times" aria-hidden="true"></i></span>
                    </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>Total</th>
                        <th class="">{{ total_validation_financiere.total_praticien }}</th>
                        <th class="text-center">{{ total_validation_financiere.total_medecin_controle }}</th>
                        <th class="text-center">{{ total_validation_financiere.total_souscripteur }}</th>
                    </tr>
                </tfoot>
            </table>
            <div>
                <h3 class="text-center text-success mt-5">Total validé: {{ total_validation_financiere.total_souscripteur }}</h3>
            </div>
        </div>
    </div>
    <div class="bilan p-0 m-0" v-else>
        <div class="row p-0 m-0" v-if="validation_financiere_ligne_temps.length > 0">
            <p class="col-12 col-md-6 p-0 m-0"><span class="font-weight-bold">Validation Medicasure:</span>  {{ validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_medecin != null ? formattedDateTime(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_medecin) : formattedDateTime(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].created_at) }}</p>
            <p class="col-12 col-md-6 p-0 m-0"><span class="font-weight-bold">Validation Souscripteur:</span>  {{ formattedDateTime(validation_financiere_ligne_temps[validation_financiere_ligne_temps.length -1].date_validation_souscripteur) }}</p>
        </div>
        <div class="card-body p-0 m-0" v-for="(validation, index_val) in validation_financiere_ligne_temps" :key="'validation_financiere_ligne_temp'+index_val">
            <div class="list-group-item"><p class="ligne"><span class="text-gray">EXAMENS COMPLEMENTAIRES</span>:
                <span class="font-weight-bold new-title mr-4">
                {{ validation.examen }}
                </span></p></div>
            <div class="list-group-item"><p class="ligne text-gray" ><span>PRIX</span>: 
            <span class="font-weight-bold new-title med_bilan">
                {{ displayNumber(validation.prix) }}
            </span></p></div>
            <div :class="validation.etat_validation_medecin == 1 ? 'etat_validation_1' : 'etat_validation_0'" class="list-group-item"><p class="ligne">
                <span>MEDICASURE</span>: 
                <span class="font-weight-bold text-gray med_bilan">
                    <span class="text-success" v-if="validation.etat_validation_medecin == 1"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times" aria-hidden="true"></i></span>
                </span></p>
            </div>
            <div :class="validation.etat_validation_souscripteur == 1 ? 'etat_validation_1' : 'etat_validation_0'" class="list-group-item"><p class="ligne">
                <span>SOUSCRIPTEUR</span>: 
                <span class="font-weight-bold text-gray med_bilan">
                    <span v-if="validation.etat_validation_souscripteur" class="text-success"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
                    <span v-else class="text-danger"><i class="fa fa-times" aria-hidden="true"></i></span>
                </span></p>
            </div>
        </div>
        <div>
            <h3 class="text-center text-success mt-5">Total validé: {{ total_validation_financiere.total_souscripteur }}</h3>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import moment from "moment";
export default {
    name: "BilanFinancier",
    props: ['id', 'version', 'acteur'],
    data() {
        return {
            mobileView: true,
            validation_financiere_ligne_temps: [],
            total_validation_financiere: {}
        }
    },

    methods: {
        computeTempsValidation(begin, end){
            return "2h30min";
        },
        handleView() {
            this.mobileView = window.innerWidth < 991;
        },
        displayNumber(value) {
            return Number(value).toLocaleString("fr") + " XAF";
        },
        PraticienExamen: function(data) {
            return this.displayNumber(data.reduce((accumulator, validation) => {
            return accumulator + Number(validation.prix);
            }, 0))
        },
        MedecinControleExamen: function(data) {
            return this.displayNumber(data.filter(item => item.etat_validation_medecin).reduce((accumulator, validation) => {
            return accumulator + Number(validation.prix);
            }, 0));
        },
        AssureurExamen: function(data) {
            return this.displayNumber(data.filter(item => item.etat_validation_souscripteur).reduce((accumulator, validation) => {
            return accumulator + Number(validation.prix);
            }, 0));
        },
        formattedDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return date;
            }
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getDetails(ligne_temps_id, version, acteur){
            axios.get(AppConfig.apiUrl+`/examens/validations/${ligne_temps_id}/${version}/${acteur}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}}).then(res => {
                this.validation_financiere_ligne_temps = res.data;
                this.total_validation_financiere = {total_praticien: this.PraticienExamen(res.data), total_medecin_controle: this.MedecinControleExamen(res.data), total_souscripteur: this.AssureurExamen(res.data)};
            }).catch(error => {
                console.log('error ', error);
            })
        }
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        this.getDetails(this.id, this.version, this.acteur);
    }
}
</script>
<style lang="">
    
</style>